class FilterNativeSelect extends HTMLElement {
  constructor() {
    super();

    this.collectionUrl = this.getAttribute('collection-url');
    this.filterTitle = this.getAttribute('filter-title');

    this.loadOptions();
  }

  loadOptions() {
    const _this = this;
    let url = `${location.origin}/${this.collectionUrl}?view=filter-options&filter=${this.filterTitle}&native_options=true`;

    fetch(url)
      .then(res => res.text())
      .then(text => {
        const options = text.trim();
        console.log('--options---', options);
        if (!options) return;
        _this.appendOptions(options);
      })
  }

  appendOptions(options) {
    this.querySelector('select').innerHTML = '<option></option>' + options;
  }
}
customElements.define('filter-native-select', FilterNativeSelect);

class FilterSelect extends HTMLElement {
  constructor() {
    super();

    this.totalFilters = Number(this.dataset.totalFilters);
    this.index = Number(this.dataset.index);
    this.values = '';
    this.isTheFirstOne = this.hasAttribute('is-the-first');
    this.isTheLastOne = this.hasAttribute('is-the-last');
    this.collectionUrl = this.dataset.collectionUrl;
    this.filterTitle = this.dataset.filterTitle;
    this.ELM_filterPanel = this.closest('filter-panel');
    this.ELM_placeholder = this.querySelector('[placeholder-field]');
    this.ELM_currentValues = this.querySelector('[current-values]');
    this.ELM_dropdown = this.querySelector('[filter-options]');
    this.ELM_toggleDropdown = this.querySelector('[toggle-dropdown]');

    this.correctedItemsActiveState = false;

    this.ELM_toggleDropdown.addEventListener('click', this.toggleDropdown.bind(this));
    document.addEventListener('click', e => {
      if (this.ELM_toggleDropdown.contains(e.target)) return;
      if (!this.ELM_dropdown.contains(e.target)) {
        this.hideDropdown();
      }
    })
  }

  loadOptions() {
    this.classList.remove('loaded');
    this.enableFilter();
    const _this = this;
    const params = this.ELM_filterPanel.getParams();
    let url = `${location.origin}/${this.collectionUrl}?view=filter-options&filter=${this.filterTitle}`;
    if (params) {
      url += `&${ params }`;
    }
    fetch(url)
      .then(res => res.text())
      .then(text => {
        const options = text.trim();
        if (!options) return;
        _this.appendOptions(options);
      })
  }

  appendOptions(fetchedOptions) {
    const ELM_filterOptions = this.querySelector('[filter-options]');
    ELM_filterOptions.innerHTML = fetchedOptions;
    this.activeSelecting();
    this.correctDopdownItemActiveState();
  }

  activeSelecting() {
    const ELM_options = this.querySelectorAll('.wc-select-option');
    if (!ELM_options || !ELM_options.length) return;
    
    ELM_options.forEach(ELM_option => ELM_option.addEventListener('click', () => {
      ELM_option.toggleAttribute('checked');
      this.updateValues();
    }))
    this.classList.add('loaded');
  }

  correctDopdownItemActiveState() {
    if (this.correctedItemsActiveState) return;
    const currentValues = this.ELM_currentValues.innerHTML;
    if (currentValues) {
      currentValues.split(',').forEach(value => {
        const ELM_activeOption = this.querySelector(`.wc-select-option[value="${value}"]`);
        if (ELM_activeOption) {
          ELM_activeOption.setAttribute('checked', '');
        }
      })
    }
    this.correctedItemsActiveState = true;
  }

  updateValues() {
    const values = [];
    const ELM_checkedOptions = this.querySelectorAll('.wc-select-option[checked] [field-value]');
    ELM_checkedOptions?.forEach(ELM_checkedOption => {
      values.push(ELM_checkedOption.innerHTML);
    })
    
    if (values.length) {
      this.ELM_currentValues.innerHTML = values.join(', ');
      this.ELM_currentValues.classList.remove('wc-hidden');
      this.ELM_placeholder.classList.add('wc-hidden');
    } else {
      this.ELM_currentValues.innerHTML = '';
      this.ELM_currentValues.classList.add('wc-hidden');
      this.ELM_placeholder.classList.remove('wc-hidden');
    }
  }

  resetFilter() {
    const ELM_checkedOptions = this.querySelectorAll('.wc-select-option[checked]');
    ELM_checkedOptions?.forEach(ELM_checkedOption => {
      ELM_checkedOption.removeAttribute('checked');
    })
    this.values = '';
    this.ELM_currentValues.innerHTML = '';
    this.ELM_currentValues.classList.add('wc-hidden');
    this.ELM_placeholder.classList.remove('wc-hidden');
  }

  disableFilter() {
    this.setAttribute('disabled', true);
    this.ELM_toggleDropdown.setAttribute('disabled', true);
  }

  enableFilter() {
    this.removeAttribute('disabled');
    this.ELM_toggleDropdown.removeAttribute('disabled');
  }

  resetBackwardFilters() {
    for (let i = this.index + 1; i <= this.totalFilters; i++) {
      const ELM_filterSelect = this.ELM_filterPanel.querySelector(`filter-select[data-index="${ i }"]`);
      if (ELM_filterSelect) {
        ELM_filterSelect.querySelectorAll('.wc-select-option[checked]')?.forEach(elm => elm.removeAttribute('checked'));
        ELM_filterSelect.updateValues();
        ELM_filterSelect.disableFilter();
      }
    }
  }

  backwardFiltersOptionsReload() {
    for (let i = this.index + 1; i <= this.totalFilters; i++) {
      const ELM_filterSelect = this.ELM_filterPanel.querySelector(`filter-select[data-index="${ i }"]`);
      if (ELM_filterSelect) {
        ELM_filterSelect.loadOptions();
      }
    }
  }

  toggleDropdown() {
    this.classList.toggle('open');
    this.ELM_dropdown.classList.toggle('wc-hidden');
  }

  showDropdown() {
    this.ELM_dropdown.classList.remove('wc-hidden');
    this.classList.add('open');
  }

  hideDropdown() {
    this.ELM_dropdown.classList.add('wc-hidden');
    this.classList.remove('open');
    
    if (this.isTheFirstOne && this.ELM_currentValues.innerHTML !== this.values) {
      this.values = this.ELM_currentValues.innerHTML;
      this.resetBackwardFilters();
      if (this.values) {
        this.backwardFiltersOptionsReload();
      }
      this.ELM_filterPanel.updateButtonStatus();
    }
  }
}
customElements.define('filter-select', FilterSelect);

class FilterPanel extends HTMLElement {
  constructor() {
    super();

    this.ELM_submitButton = this.querySelector('button[type="submit"]');
    this.ELM_clearFilterButton = this.querySelector('[clear-filter-button]');

    this.ELM_submitButton.addEventListener('click', this.onSubmit.bind(this));
    this.ELM_clearFilterButton.addEventListener('click', this.clearFilter.bind(this));
    this.loadFilterOptions(1);
  }

  loadFilterOptions(index) {
    const ELM_filterSelect = this.querySelector(`filter-select[data-index="${index}"]`);
    if (!ELM_filterSelect) return;

    ELM_filterSelect.loadOptions();
  }

  clearFilter() {
    const ELM_firstFilterSelect = this.querySelector('filter-select[data-index="1"]');
    ELM_firstFilterSelect.resetFilter();
    ELM_firstFilterSelect.resetBackwardFilters();
  }

  getParams() {
    const params = [];
    const ELM_checkedOptions = this.querySelectorAll('.wc-select-option[checked]');
    if (!ELM_checkedOptions || !ELM_checkedOptions.length) return '';

    ELM_checkedOptions.forEach(ELM_checkedOption => {
      params.push(`${ELM_checkedOption.getAttribute('param')}=${ELM_checkedOption.getAttribute('value')}`);
    })

    return params.join('&');
  }

  updateButtonStatus() {
    if (this.getParams()) {
      this.enableButton();
    } else {
      this.disableButton();
    }
  }

  enableButton() {
    this.ELM_submitButton.removeAttribute('disabled');
  }

  disableButton() {
    this.ELM_submitButton.setAttribute('disabled', true);
  }

  onSubmit() {
    const collectionUrl = this.dataset.collectionUrl;
    const url = collectionUrl + '?' + this.getParams();
    location.href = url;
  }
}
customElements.define('filter-panel', FilterPanel);

class FakeSelect extends HTMLElement {
  constructor() {
    super();

    this.ELM_currentValue = this.querySelector('[current-value]');
    this.ELM_selectDropdown = this.querySelector('[select-options]');

    this.ELM_currentValue.addEventListener('click', this.toggleDropdown.bind(this));
    document.addEventListener('click', e => {
      if (this.ELM_currentValue.contains(e.target)) return;
      if (!this.ELM_selectDropdown.contains(e.target)) {
        this.hideDropdown();
      }
    })
  }

  toggleDropdown() {
    this.ELM_selectDropdown.classList.toggle('wc-hidden');
  }

  showDropdown() {
    this.ELM_selectDropdown.classList.remove('wc-hidden');
  }

  hideDropdown() {
    this.ELM_selectDropdown.classList.add('wc-hidden');
  }
}
customElements.define('fake-select', FakeSelect);

class InstallationMessage extends HTMLElement {
  constructor() {
    super();

    const beforLunchMessage = this.getAttribute('before-lunch-message');
    const afterLunchMessage = this.getAttribute('after-lunch-message');
    const timezoneOffset = 8;
    const d = new Date();
    const utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    const nowInHK = new Date(utc + (3600000 * timezoneOffset));
    const currentHour = nowInHK.getHours();
    this.innerHTML = currentHour < 16 ? beforLunchMessage : afterLunchMessage;
  }
}
customElements.define('installation-message', InstallationMessage);